<template>
  <div class="flex flex-col max-w-sm w-full">
    <fieldset v-if="options.length > limit" class="relative w-full">
      <BaseInput
        type="text"
        name="filter-options"
        v-model.trim="searchTerm"
        size="sm"
        label="filter_companies"
        clearable
      />
    </fieldset>
    <div>
      <div
        v-if="options.length > limit && value.length > 0 && showSelected"
        class="flex flex-wrap mb-2"
      >
        <span
          class="bg-primary-light px-1 py-1 flex items-center justify-between mr-2 mb-1 text-white text-xs cursor-default space-x-2"
          @click="selectedValue = []"
          v-tooltip="{content: showTooltip(selectedValue), placement: 'top'}"
        >
          <span>{{ showButton(selectedValue[0]) }}</span>
          <span v-if="selectedValue.length > 1">{{ `(+${selectedValue.length - 1})` }}</span>
          <BaseIcon class="ml-3" icon="close" />
        </span>
        <!-- <span
          class="bg-primary-light px-1 py-1 flex items-center justify-between mr-2 mb-1 text-white text-xs cursor-default"
          v-for="(val, index) in value"
          @click="value.splice(index, 1)"
          :key="index"
        >
          <span class="pl-1">{{ showButton(val) }}</span>
          <BaseIcon class="ml-2" icon="close" />
        </span> -->
      </div>
      <div class="overflow-y-auto h-64 bg-white">
        <template v-for="row in options">
          <!-- <BaseCheck v-show="isFiltered(row)" v-model="selectedRows"
            ><div class="ml-3" v-html="showLabel(row)"></div
          ></BaseCheck> -->
          <label
            :key="row[optionType.value]"
            :class="[
              'items-center p-1 leading-normal hover:bg-secondary-light border-b',
              isFiltered(row) ? 'flex' : 'hidden',
            ]"
            :for="`list-${row[optionType.value]}`"
          >
            <input
              class="input-checkbox"
              type="checkbox"
              :id="`list-${row[optionType.value]}`"
              :aria-label="row[optionType.label]"
              role="checkbox"
              :value="row[optionType.value].toString()"
              v-on="inputListeners"
              :checked="value.indexOf(row[optionType.value].toString()) > -1"
            />
            <p class="ml-3" v-html="showLabel(row)"></p>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {BaseIcon, BaseInput} from '@/components/base'

export default {
  components: {
    BaseIcon,
    BaseInput,
  },
  mounted() {},
  inheritAttrs: false,
  data() {
    return {
      searchTerm: '',
      selectedValue: this.selected,
    }
  },
  methods: {
    isFiltered(value) {
      const matcher = new RegExp(this.searchTerm, 'i')
      return (
        matcher.test(value[this.optionType.label]) || this.filters.some(k => matcher.test(value[k]))
      )
    },
    showLabel(value) {
      const info = this.filters.map(k => value[k])
      return `<div class="flex flex-col w-full"><div class="text-ellipsis">${
        value[this.optionType.label]
      }</div><span class="text-xs opacity-50">${info.filter(Boolean).join(' - ')}</span></div>`
    },
    showButton(value) {
      const index = this.options.findIndex(row => +row[this.optionType.value] === +value)
      return this.options[index][this.optionType.label]
    },
    showTooltip(values) {
      const t = this.options.reduce((acc, row) => {
        if (values.includes(row[this.optionType.value])) {
          return [...acc, row[this.optionType.label]]
        }
        return acc
      }, [])
      return t.join('<br>')
    },
  },
  watch: {
    selectedValue: {
      immediate: false,
      handler(n, o) {
        this.$emit('update', n)
      },
    },
  },
  computed: {
    // selectedRows: {
    //   get() {
    //     return this.selected
    //   },
    //   set(value) {
    //     this.$emit('update:selected', value)
    //   },
    // },
    inputListeners: function () {
      var vm = this
      return Object.assign({}, this.$listeners, {
        change: function (event) {
          const input = event.target.value.toString()
          const index = vm.value.indexOf(input)
          if (index > -1) {
            vm.value.splice(index, 1)
          } else {
            vm.value.push(input)
          }
          vm.$emit('update', vm.value)
        },
      })
    },
  },
  props: {
    value: {
      type: [Number, Array, Object, String],
    },
    options: {
      type: Array,
      default: function () {
        return []
      },
    },
    selected: {
      type: Array,
      default: function () {
        return []
      },
    },
    optionType: {
      type: Object,
      default: function () {
        return {
          value: 'id',
          label: 'name',
        }
      },
    },
    filters: {
      type: Array,
      default: () => ['customer_account', 'city', 'country', 'area'],
    },
    showSelected: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 5,
    },
  },
  model: {
    event: 'update',
  },
}
</script>

<style scoped>
.scroll-list .list-options {
  max-height: 9rem;
}
</style>
